export const Issues = [
  {
    id: Math.random() * 10,
    Unique_Id: "#189324",
    createdAt: "16-02-2022 01:29PM",
    by: "OELPL - Mahesh Rode",
    Issue_Related_To: "ERROR/Others",
    Issue_Subject:
      "Bill No PNQ/22-23/224 this bill no is not showing in List of Bills (FY 22-23) and their LRs is showing in Pending Bill list of FY 22-23",
    Issue_Details:
      "Bill No PNQ/22-23/224 this bill no is not showing in List of Bills (FY 22-23) and their LRs is showing in Pending Bill list of FY 22-23",
    Imag: ["image 1"],
  },
  {
    id: Math.random() * 10,
    Unique_Id: "#189324",
    createdAt: "16-02-2022 01:29PM",
    by: "OELPL - Mahesh Rode",
    Issue_Related_To: "ERROR/Others",
    Issue_Subject:
      "Bill No PNQ/22-23/224 this bill no is not showing in List of Bills (FY 22-23) and their LRs is showing in Pending Bill list of FY 22-23",
    Issue_Details:
      "Bill No PNQ/22-23/224 this bill no is not showing in List of Bills (FY 22-23) and their LRs is showing in Pending Bill list of FY 22-23",
    Imag: ["image 1"],
  },
];

export const DocUpload = [
  {
    id: Math.random() * 10,
    name: "Attachment",
    label: " Attachment",
  },
];
